import type { Translatable } from "app/pages/sales-intelligence/types";

export const PANEL_TITLE_TRANSLATABLE: Translatable = { key: "si.multi_selector.move_to_list.title" };
